import { all, put, call, getContext, takeEvery } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { leads } from './types';
import { requestLeadsFailure, requestLeadsSuccess } from './actions';

const logger = new Logger('Saga:Leads');

export function* requestLeadsSaga({ filter }) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.leads', { filter }),
    );

    yield put(requestLeadsSuccess(response.data, filter));
  } catch (error) {
    logger.error('Failed to request leads with the following error', error);
    yield put(requestLeadsFailure(filter));
  }
}

export default function* fundingSearchSaga() {
  return yield all([takeEvery(leads.request, requestLeadsSaga)]);
}
